<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <paginated-table :id="$attrs['id']"
                   :rows="reversedHistory"
                   :hover="false"
                   columns="5"
                   min-width="600px">
    <template slot="table-head">
      <div class="hm-table__th">{{ $t('table.historyTable.field') }}</div>
      <div class="hm-table__th">{{ $t('table.historyTable.oldValue') }}</div>
      <div class="hm-table__th">{{ $t('table.historyTable.newValue') }}</div>
      <div class="hm-table__th">{{ $t('table.historyTable.user') }}</div>
      <div class="hm-table__th">{{ $t('table.historyTable.timestamp') }}</div>
    </template>
    <template v-slot:default="slotProps">
      <template v-for="row in slotProps.currentPage">
        <div class="hm-table__td">{{ $t(`FieldName.${row.field}`) }}</div>
        <!-- OLD -->
        <div v-if="row.format === 'GuestProfile'" :class="[{'hm-table__td--clickable': !isEmpty(row.oldValue)}]" class="hm-table__td privacy--blur" @click="routeToGuestProfile(row.oldValue)">{{ !isEmpty(row.oldValue) && isEmpty(row.oldLabel) ? '-' : row.oldLabel }}</div>
        <div v-else-if="row.format === 'RoomType'" class="hm-table__td">{{ isEmpty(row.oldValue) ? '' : findHotelSettingById('roomTypes', row.oldValue).name[$shortLocale] }}</div>
        <div v-else-if="row.format === 'RatePlan'" class="hm-table__td">{{ isEmpty(row.oldValue) ? '' : findHotelSettingById('ratePlans', row.oldValue).name[$shortLocale] }}</div>
        <div v-else-if="row.format === 'Season'" class="hm-table__td">{{ isEmpty(row.oldValue) ? '' : findHotelSettingById('seasons', row.oldValue).name[$shortLocale] }}</div>
        <div v-else-if="row.format === 'LocalDate'" class="hm-table__td">{{ row.oldValue | toDate }}</div>
        <div v-else-if="row.format === 'Currency'" class="hm-table__td">{{ row.oldValue | toCurrency }}</div>
        <div v-else-if="row.format === 'Integer'" class="hm-table__td">{{ row.oldValue }}</div>
        <div v-else-if="row.format === 'Enum'" class="hm-table__td">{{ isNil(row.oldValue) ? '' : $t(`${row.field}.${row.oldValue}`) }}</div>
        <div v-else class="hm-table__td privacy--blur">{{ row.oldValue }}</div>
        <!-- NEW -->
        <div v-if="row.format === 'GuestProfile'" :class="[{'hm-table__td--clickable': !isEmpty(row.newValue)}]" class="hm-table__td privacy--blur" @click="routeToGuestProfile(row.newValue)">{{ !isEmpty(row.newValue) && isEmpty(row.newLabel) ? '-' : row.newLabel }}</div>
        <div v-else-if="row.format === 'RoomType'" class="hm-table__td">{{ isEmpty(row.newValue) ? '' : findHotelSettingById('roomTypes', row.newValue).name[$shortLocale] }}</div>
        <div v-else-if="row.format === 'RatePlan'" class="hm-table__td">{{ isEmpty(row.newValue) ? '' : findHotelSettingById('ratePlans', row.newValue).name[$shortLocale] }}</div>
        <div v-else-if="row.format === 'Season'" class="hm-table__td">{{ isEmpty(row.newValue) ? '' : findHotelSettingById('seasons', row.newValue).name[$shortLocale] }}</div>
        <div v-else-if="row.format === 'LocalDate'" class="hm-table__td">{{ row.newValue | toDate }}</div>
        <div v-else-if="row.format === 'Currency'" class="hm-table__td">{{ row.newValue | toCurrency }}</div>
        <div v-else-if="row.format === 'Integer'" class="hm-table__td">{{ row.newValue }}</div>
        <div v-else-if="row.format === 'Enum'" class="hm-table__td">{{ isNil(row.newValue) ? '' : $t(`${row.field}.${row.newValue}`) }}</div>
        <div v-else class="hm-table__td privacy--blur">{{ row.newValue }}</div>
        <!-- Other fields -->
        <div class="hm-table__td privacy--blur">{{ row.username }}</div>
        <div class="hm-table__td">{{ row.dateTime | toDateTime }}</div>
      </template>
    </template>
  </paginated-table>
</template>

<script>

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { split, endsWith, head, isNil, isEmpty, slice, cloneDeep } from 'lodash';

export default {
  name: 'HistoryTable',

  mixins: [HotelmeisterMixin],

  props: {
    history: {
      type: Array,
      required: true,
      default: () => [],
    },
  },

  data: function () {
    return {
    };
  },

  computed: {
    reversedHistory: function () {
      return isNil(this.history) ? null : cloneDeep(this.history).reverse();
    },
  },

  methods: {
    routeToGuestProfile(guestProfileId) {
      if (this.isEmpty(guestProfileId)) return;

      this.$router.push({
        name: 'guest',
        params: {
          guestProfileId: guestProfileId,
        },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "~styles/import";
</style>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/lib/table/HistoryTable.vue